const ProductAPI = {
   getProducts (barangay_code, brand_id, main_category_id,sub_category_id, is_deal, is_gifting, sort_by, filter_by, wildcard, item_per_page, ratings, sku_list, page) {
    return new Promise((resolve, reject) => {
      const response = fetch('/static/api/products.php', {
        method: 'POST',
        body: JSON.stringify({
         'barangay_code': barangay_code,
         'brand_id': brand_id,
         'main_category_id': main_category_id,
         'sub_category_id': sub_category_id,
         'is_deal': is_deal,
         'is_gifting': is_gifting,
         'sort_by': sort_by,
         'filter_by': filter_by,
         'wildcard': wildcard,
         'item_per_page': item_per_page,
         'ratings': ratings,
         'sku_list': sku_list,
         'page': page,
        })
      })
        .then(response => response.json())
        .then(response => {
          if (response.products) {
            var new_response = {
              status: 'success',
              remarks: 'Products successfully fetched',
              products: response.products,
              item_total: response.item_total,
            }

            resolve(new_response)
          } else {
            var new_response = {
              status: 'failed',
              remarks: response
            }

            resolve(new_response)
          }
        })
    })
  },
  getProductDetails (barangay_code, sku_id) {
    return new Promise((resolve, reject) => {
      const response = fetch('/static/api/product_details.php', {
        method: 'POST',
        body: JSON.stringify({ 'barangay_code': barangay_code, 'sku_id': sku_id })
      })
        .then(response => response.json())
        resolve(response)
    })
  },
  checkInventory (products) {
    return new Promise((resolve, reject) => {
      const response = fetch('/static/api/product_inventory_check.php', {
        method: 'POST',
        body: JSON.stringify({ 'products': products })
      })
        .then(response => response.json())
        resolve(response)
    })
  },
  getFeaturedProducts (barangay_code, type) {
    return new Promise((resolve, reject) => {
      const response = fetch('/static/api/product_featured.php', {
        method: 'POST',
        body: JSON.stringify({ 'barangay_code': barangay_code, 'type': type })
      })
        .then(response => response.json())
        resolve(response)
    })
  },
  getProductReview (sku_id) {
    return new Promise((resolve, reject) => {
      const response = fetch('/static/api/product_review.php', {
        method: 'POST',
        body: JSON.stringify({ 'sku_id': sku_id })
      })
        .then(response => response.json())
        resolve(response)
    })
  },
  saveSearchKeyword (keyword) {
    return new Promise((resolve, reject) => {
      const response = fetch('/static/api/save_kw.php', {
        method: 'POST',
        body: JSON.stringify({ 'keyword': keyword })
      })
        .then(response => response.json())
        resolve(response)
    })
  }
}
export default ProductAPI



// WEBPACK FOOTER //
// ./src/api/product.js